module.exports = __webpack_public_path__ + "static/img/rebel_pictgrid30_980x867.c4dd92a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/rebel_pictgrid30_980x867.jpg
// module id = w50j
// module chunks = 0